import styled from 'styled-components'

export const MondalContent = styled.div`
  font-weight: 700;
  margin: 25px;
`
